// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BDgh71dKXlYE_3ceVHyd{display:flex;align-items:stretch;flex-wrap:nowrap;flex-direction:column;align-content:center;justify-content:center;gap:1em;width:100%;height:fit-content;margin-top:2em;margin-bottom:2em}.Lr41S9R2N9m1bGEARLsx{flex:1;height:fit-content;display:flex;justify-content:center;gap:2em}.Lr41S9R2N9m1bGEARLsx .olDxbVWOJyCSOVsQwszQ{min-height:100%;max-width:1px;flex:1;background-color:#321e78}.qvQ4Ig3u1NYwr3r7N8de{flex:0;display:flex;flex-direction:column;align-items:center;gap:.5em}.qvQ4Ig3u1NYwr3r7N8de .yU0c0RcDd51Ay0hSKLp7{display:flex;min-width:300px;width:50%;align-items:center;justify-content:stretch;gap:1em}.qvQ4Ig3u1NYwr3r7N8de .yU0c0RcDd51Ay0hSKLp7>div:first-child{flex-basis:23%;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"pageWrapper": `BDgh71dKXlYE_3ceVHyd`,
	"imagesRow": `Lr41S9R2N9m1bGEARLsx`,
	"separator": `olDxbVWOJyCSOVsQwszQ`,
	"slidersRow": `qvQ4Ig3u1NYwr3r7N8de`,
	"sliderRow": `yU0c0RcDd51Ay0hSKLp7`
};
export default ___CSS_LOADER_EXPORT___;
